/**
 * Maps commentator mood strings to OKLCh hue values for accent colors.
 */
const MOOD_HUE_MAP: Record<string, number> = {
  excited: 55, // gold
  disgusted: 145, // green
  shocked: 250, // blue
  smug: 310, // purple
  furious: 28, // red
  amused: 80, // warm yellow-green
  neutral: 55, // default gold
}

export function moodHue(mood: string | undefined): number {
  return MOOD_HUE_MAP[mood ?? "neutral"] ?? MOOD_HUE_MAP.neutral
}

/** Returns an oklch color string at the given lightness and chroma for a mood. */
export function moodColor(
  mood: string | undefined,
  lightness = 0.65,
  chroma = 0.15,
): string {
  return `oklch(${lightness} ${chroma} ${moodHue(mood)})`
}

/** Returns a subtle background tint for a mood. */
export function moodBg(mood: string | undefined): string {
  return `oklch(0.22 0.04 ${moodHue(mood)} / 0.4)`
}

/** Returns a border ring color for a mood. */
export function moodRing(mood: string | undefined): string {
  return `oklch(0.55 0.15 ${moodHue(mood)})`
}
